import React, {useMemo} from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {datetime, objects} from "@atttomyx/shared-utils";
import {ANSWER_TYPE_DOUBLE, ANSWER_TYPE_INTEGER} from "../../constants";

const QuestionCard = (props) => {
    const { question, filters, children } = props;

    const keyToMetadata = useMemo(() => {
        const ret = {
            type: {
                title: "Type",
            },
        };

        if (question.type === ANSWER_TYPE_INTEGER || question.type === ANSWER_TYPE_DOUBLE) {
            const metadata = objects.defaultIfNullOrUndefined(question.metadata);

            ret.min = {
                title: "Min",
                getter: (data) => metadata.min,
            };

            ret.max = {
                title: "Max",
                getter: (data) => metadata.max,
            };
        }

        ret.order = {
            title: "Index",
        };

        ret.created = {
            title: "Created",
            formatter: datetime.getFullDateAndTime,
        };

        ret.updated = {
            title: "Updated",
            formatter: datetime.getFullDateAndTime,
        };

        return ret;
    }, [question]);

    return <Card className="question-card" raised={true}>
        <CardContent>
            <CardTitle>
                {question.ask}
            </CardTitle>
            <CardData
                filters={filters}
                data={question}
                keyToMetadata={keyToMetadata}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default QuestionCard;
